import { Green, Span } from "../../styledCpns/DataDisplay";

const caStaminaMaker = (stamina) => ({
  name: "Charged Attack Stamina Cost",
  noCalc: true,
  getValue: () => stamina
});
export const CaStamina = {
  20: caStaminaMaker(20),
  25: caStaminaMaker(25),
  50: caStaminaMaker(50)
};

// ----- SWORD -----
export const SwordNaDesc = {
  heading: "NA",
  content: <>Performs up to 5 rapid strikes.</>
};
export const SwordCaDesc = {
  heading: "CA",
  content: (
    <>Consumes a certain amount of Stamina to unleash 2 rapid sword strikes.</>
  )
};
export const SwordPaDesc_content = (
  <>
    Plunges from mid-air to strike the ground below, damaging opponents along
    the path and dealing AoE DMG upon impact.
  </>
);
export const SwordPaDesc = {
  heading: "PA",
  content: SwordPaDesc_content
};
export const SwordDesc = [SwordNaDesc, SwordCaDesc, SwordPaDesc];

// ----- CLAYMORE -----
export const CaStaminaClaymore = [
  {
    name: "Charged Attack Stamina Cost",
    noCalc: true,
    getValue: () => "40/s"
  },
  {
    name: "Max Duration",
    noCalc: true,
    getValue: () => "5s"
  }
];

const claymoreDescMaker = (n, type) => [
  { heading: "NA", content: <>Performs up to {n} consecutive strikes.</> },
  {
    heading: "CA",
    content: (
      <>
        Drains Stamina over time to perform continuous{" "}
        {type ? "spinning attacks against all nearby opponents" : "slashes"}.
        <br />
        At the end of the sequence, perform a more powerful slash.
      </>
    )
  },
  SwordPaDesc
];
export const ClaymoreDesc_4spin = claymoreDescMaker(4, 0);
export const ClaymoreDesc_5slash = claymoreDescMaker(5, 1);
export const ClaymoreDesc_4slash = claymoreDescMaker(4, 1);

// ----- CATALYST -----
const catalystCaDescMaker = (elmt) => ({
  heading: "CA",
  content: (
    <>
      Consumes a certain amount of Stamina to deal AoE{" "}
      <Span color={elmt}>{elmt} DMG</Span> after a short casting time.
    </>
  )
});
export const CatalystCaDesc_Pyro = catalystCaDescMaker("Pyro");
export const CatalystCaDesc_Hydro = catalystCaDescMaker("Hydro");
export const CatalystCaDesc_Electro = catalystCaDescMaker("Electro");
export const CatalystCaDesc_Geo = catalystCaDescMaker("Geo");
export const CatalystCaDesc_Anemo = catalystCaDescMaker("Anemo");

export const CatalystPaDesc = (elmt, name) => ({
  heading: "CA",
  content: (
    <>
      Gathering the might of {elmt}, {name} plunges towards the ground from
      mid-air, damaging all opponents in her path. Deals AoE{" "}
      <Span color={elmt}>{elmt} DMG</Span> upon impact with the ground.
    </>
  )
});

// ----- BOW -----
const bowNaDescMaker = (n) => ({
  heading: "NA",
  content: <>Perform up to {n} consecutive shots with a bow.</>
});
export const BowNaDesc_4 = bowNaDescMaker(4);
export const BowNaDesc_5 = bowNaDescMaker(5);
export const BowNaDesc_6 = bowNaDescMaker(6);

export const BowCaDesc_contentMaker = (thing1, thing2, elmt) => (
  <>
    Perform a more precise Aimed Shot with increased DMG.
    <br />
    While aiming, {thing1} will accumulate on the arrowhead. {thing2} will deal{" "}
    <Span color={elmt}>{elmt} DMG</Span>.
  </>
);
export const BowCaDesc = (thing1, thing2, elmt) => ({
  heading: "CA",
  content: BowCaDesc_contentMaker(thing1, thing2, elmt)
});

export const BowPaDesc_content = (
  <>
    Fires off a shower of arrows in mid-air before falling and striking the
    ground, dealing AoE DMG upon impact.
  </>
);
export const BowPaDesc = {
  heading: "PA",
  content: BowPaDesc_content
};

// ----- POLEARM -----
const polearmNaDescMaker = (n) => ({
  heading: "NA",
  content: <>Performs up to {n} consecutive spear strikes.</>
});
export const PolearmNaDesc_5 = polearmNaDescMaker(5);
export const PolearmNaDesc_6 = polearmNaDescMaker(6);

const PolearmCaDesc = (
  <>
    Consumes a certain amount of Stamina to lunge forward, dealing damage to
    opponents along the way.
  </>
);
export const PolearmUpCaDesc = {
  heading: "CA",
  content: (
    <>Consumes a certain amount of Stamina to perform an upward thrust.</>
  )
};

const polearmDescMaker = (n) => [
  { ...polearmNaDescMaker(n) },
  { heading: "CA", content: PolearmCaDesc },
  SwordPaDesc
];
export const PolearmDesc_4 = polearmDescMaker(4);
export const PolearmDesc_5 = polearmDescMaker(5);
export const PolearmDesc_6 = polearmDescMaker(6);

// ----- common passive -----

export const doubleCooking = (name, dish) => (
  <>
    When a Perfect Cooking is achieved on a <Green>{dish}</Green>, {name} has a{" "}
    <Green b>12%</Green> <Green>chance</Green> to obtain <Green b>double</Green>{" "}
    the product.
  </>
);

export const susCooking = (name, gender) => (
  <>
    When {name} cooks a dish perfectly, {gender} has a <Green b>18%</Green>{" "}
    chance to receive <Green b>an additional</Green>{" "}
    <Green>"Suspicious" dish</Green> of the same type.
  </>
);

export const sprintStaminaPasv = (
  <>
    Decreases <Green>sprinting Stamina consumption</Green> for your own party
    members by <Green b>20%</Green>.
    <br />
    Not stackable with Passive Talents that provide the exact same effects.
  </>
);

export const swimStaminaPasv = (
  <>
    Decreases <Green>swimming Stamina consumption</Green> for your own party
    members by <Green b>20%</Green>.
    <br />
    Not stackable with Passive Talents that provide the exact same effects.
  </>
);

export const glideStaminaPasv = (
  <>
    Decreases <Green>gliding Stamina consumption</Green> for your own party
    members by <Green b>20%</Green>.<br />
    Not stackable with Passive Talents that provide the exact same effects.
  </>
);

// ----- common stats -----
export const bowCAs = [
  {
    name: "Aimed Shot",
    dmgTypes: ["CA", "Physical"],
    baseMult: 43.86,
    multType: 7
  },
  {
    name: "Fully-charged Aimed Shot",
    dmgTypes: ["CA", "Elemental"],
    baseMult: 124,
    multType: 2
  }
];

const lightPAsMaker = (wp) => {
  const type = wp === "bow" ? "Physical" : "Elemental";
  return [
    {
      name: "Plunge DMG",
      dmgTypes: ["PA", type],
      baseMult: 56.83,
      multType: 7
    },
    {
      name: "Low Plunge",
      dmgTypes: ["PA", type],
      baseMult: 113.63,
      multType: 7
    },
    {
      name: "High Plunge",
      dmgTypes: ["PA", type],
      baseMult: 141.93,
      multType: 7
    }
  ];
};
export const lightPAs_Bow = lightPAsMaker("bow");
export const lightPAs_Catalyst = lightPAsMaker("catalyst");

// sword & polearm
export const mediumPAs = [
  {
    name: "Plunge DMG",
    dmgTypes: ["PA", "Physical"],
    baseMult: 63.93,
    multType: 7
  },
  {
    name: "Low Plunge",
    dmgTypes: ["PA", "Physical"],
    baseMult: 127.84,
    multType: 7
  },
  {
    name: "High Plunge",
    dmgTypes: ["PA", "Physical"],
    baseMult: 159.68,
    multType: 7
  }
];

// claymore
export const heavyPAs = [
  {
    name: "Plunge DMG",
    dmgTypes: ["PA", "Physical"],
    baseMult: 74.59,
    multType: 7
  },
  {
    name: "Low Plunge",
    dmgTypes: ["PA", "Physical"],
    baseMult: 149.14,
    multType: 7
  },
  {
    name: "High Plunge",
    dmgTypes: ["PA", "Physical"],
    baseMult: 186.29,
    multType: 7
  }
];

// Xiao, Kazuha, Itto
export const xiaoPAs = [
  {
    name: "Plunge DMG",
    dmgTypes: ["PA", "Physical"],
    baseMult: 81.83,
    multType: 7
  },
  {
    name: "Low Plunge",
    dmgTypes: ["PA", "Physical"],
    baseMult: 163.63,
    multType: 7
  },
  {
    name: "High Plunge",
    dmgTypes: ["PA", "Physical"],
    baseMult: 204.39,
    multType: 7
  }
];

export const TravelerInfo = {
  icon: "5/59/Traveler_Icon",
  sideIcon: "3/35/Character_Lumine_Side_Icon",
  rarity: 5,
  nation: "Outland",
  weapon: "Sword",
  stats: [
    { "Base HP": 912, "Base ATK": 18, "Base DEF": 57 },
    { "Base HP": 2342, "Base ATK": 46, "Base DEF": 147 },
    { "Base HP": 3024, "Base ATK": 59, "Base DEF": 190 },
    { "Base HP": 4529, "Base ATK": 88, "Base DEF": 284 },
    { "Base HP": 5013, "Base ATK": 98, "Base DEF": 315, "ATK%": 6 },
    { "Base HP": 5766, "Base ATK": 113, "Base DEF": 362, "ATK%": 6 },
    { "Base HP": 6411, "Base ATK": 125, "Base DEF": 402, "ATK%": 12 },
    { "Base HP": 7164, "Base ATK": 140, "Base DEF": 450, "ATK%": 12 },
    { "Base HP": 7648, "Base ATK": 149, "Base DEF": 480, "ATK%": 12 },
    { "Base HP": 8401, "Base ATK": 164, "Base DEF": 527, "ATK%": 12 },
    { "Base HP": 8885, "Base ATK": 174, "Base DEF": 558, "ATK%": 18 },
    { "Base HP": 9638, "Base ATK": 188, "Base DEF": 605, "ATK%": 18 },
    { "Base HP": 10122, "Base ATK": 198, "Base DEF": 635, "ATK%": 24 },
    { "Base HP": 10875, "Base ATK": 212, "Base DEF": 683, "ATK%": 24 }
  ]
};

export const TravelerNCPAs = [
  {
    name: "1-Hit",
    dmgTypes: ["NA", "Physical"],
    baseMult: 44.46,
    multType: 1
  },
  {
    name: "2-Hit",
    dmgTypes: ["NA", "Physical"],
    baseMult: 43.43,
    multType: 1
  },
  {
    name: "3-Hit",
    dmgTypes: ["NA", "Physical"],
    baseMult: 52.98,
    multType: 1
  },
  {
    name: "4-Hit",
    dmgTypes: ["NA", "Physical"],
    baseMult: 58.31,
    multType: 1
  },
  {
    name: "5-Hit",
    dmgTypes: ["NA", "Physical"],
    baseMult: 70.78,
    multType: 1
  },
  {
    name: "Charged Attack",
    dmgTypes: ["CA", "Physical"],
    baseMult: [55.9, 72.24],
    multType: 1
  },
  CaStamina[20],
  ...mediumPAs
];
